import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let cached = null;
let inflight = null;

/**
 * Returns the app version string (e.g. "2.1") fetched from the backend.
 * Cached at module level so repeated mounts don't refetch.
 * Falls back to "—" while loading and to "2.0" if the request fails.
 */
export function useAppVersion() {
  const [version, setVersion] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = axios
        .get(`${API}/version`)
        .then((r) => {
          cached = r.data?.version || "2.0";
          return cached;
        })
        .catch(() => {
          cached = "2.0";
          return cached;
        });
    }
    let alive = true;
    inflight.then((v) => {
      if (alive) setVersion(v);
    });
    return () => {
      alive = false;
    };
  }, []);

  return version || "…";
}
